<script>
import { mapActions, mapGetters } from 'vuex'
import Action from '@/components/Action'
import Icon from '@/components/Icon'
import FilterSearch from '@/components/FilterSearch'
import ProductDetail from '@/components/ProductDetail'
import OrderCart from '@/components/OrderCart'
import ModalNewOrder from '@/components/ModalNewOrder'
import ContentLoading from '@/components/ContentLoading'
import ModalConfirmationPecas from '@/components/ModalConfirmationPecas.vue'
import ModalHeader from '@/components/ModalHeader'
import ModalPecas from '@/components/ModalPecas'
import Table from '@/components/Table.vue'
import ProgressBar from 'vue-simple-progress'
import logger from '@/logger/index'
import TabNav from '@/components/TabNav.vue'
import Tab from '@/components/Tab.vue'
import VehiclePlateSearch from './VehiclePlateSearch.vue'
import NoResultsMessage from '@/components/NoResultsMessage.vue'
import SideBar from '@/components/SideBar.vue'
import ProductFilters from '@/components/ProductFilters.vue'
import { getUserErrorMessage } from '@/services/userError'
import BaseCard from '@/components/BaseCard.vue'
import { createSearchGuard } from '@/utils/searchGuard'

const FILTER_FIELD_LABELS = {
  grupo_nome: 'Grupo',
  grupo_tipo: 'Tipo',
  grupo_familia: 'Família',
  marca_nome: 'Marca',
  linha_nome: 'Linha',
  descricao_curta: 'Descrição curta',
  aumentarRelevancia: 'Relevância',
}

// const TABLE_STATES = {
//   HIDDEN: 0,
//   CONJUNTO_PECAS: 1,
//   PRODUTOS_CONJUNTO: 2,
//   ALERT_WITHOUT_STOCK: 3,
//   LOADING: 4,
//   INSERT_PRODUCTS: 5,
// }

export default {
  name: 'Products',

  components: {
    Action,
    Icon,
    FilterSearch,
    ProductDetail,
    OrderCart,
    ModalNewOrder,
    ContentLoading,
    ModalConfirmationPecas,
    ModalHeader,
    ModalPecas,
    Table,
    ProgressBar,
    TabNav,
    Tab,
    VehiclePlateSearch,
    NoResultsMessage,
    SideBar,
    ProductFilters,
    BaseCard,
  },

  data () {
    return {
      pendingProducts: [], // Armazena produtos pendentes de confirmação
      confirmedProducts: [], // Armazena produtos confirmados
      invalidProducts: [], // Produtos inválidos/não cadastrados coletados durante verifyProduct
      showUnregisteredModal: false,
      currentUnregisteredProduct: null,
      selected: 0,
      gtoken: '',
      dados: null,
      inProgress: false,
      itens: [],
      loading: false,
      loadingCart: false,
      loadingParts: false,
      loadingProduct: false,
      // true só durante a espera do carrinho DEPOIS do clique em Adicionar —
      // é o que troca o rótulo do botão, sem afetar o texto antes do clique.
      awaitingCart: false,
      loadingProgressBar: false,
      loadingSearch: false,
      loadingTable: false,
      loadingTableStock: false,
      opacity: 0,
      progress: 0,
      productNotFound: false,
      quantity: 1,
      search: null,
      selectedPartProducts: null,
      showModalNewOrder: false,
      showModal: false,
      showModalAlert: false,
      showSideBarModal: false,
      visibleTable: 0,
      lastPartsSearchedKey: null,
      filters: [
        {
          label: 'Descrição, Original ou Indústria',
          value: 'descricao',
          icon: 'search',
        },
        {
          label: 'Cód. Scherer',
          value: 'codigo',
          icon: 'package',
        }
      ],
      filter: 'descricao',
      modalFocusStack: [], // Gerencia os modais abertos (o último é o que está em foco)
      showFilter: false,
      productFilters: {
        grupo_nome: '',
        grupo_tipo: '',
        grupo_familia: '',
        marca_nome: '',
        linha_nome: '',
        descricao_curta: '',
        aumentarRelevancia: '',
      },
      /** Se o painel de filtros já foi auto-aberto nesta sessão (evita reabrir após o usuário fechar). */
      didAutoOpenFilters: false,
      /** Timer do debounce de re-busca quando filtros mudam */
      filterDebounceTimer: null,
    }
  },

  computed: {
    ...mapGetters('orders', [
      'orders',
      'getSelectedOrder',
      'getStatusTable',
      'isLoadingOrderCart',
      'hasLoadedOrderCart',
      'getOrderCartError'
    ]),
    ...mapGetters('products', ['getAllProducts', 'getSelectedProduct', 'getPartProducts', 'getSelectedParts', 'getAllRelatedProducts', 'getAllParts', 'getBoolSelectedPartsProducts', 'getLastSearchTerm', 'getAggregations', 'getAppliedFilters', 'getFiltersPanelOpen']),
    ...mapGetters('userPermissions', ['getBlockSale', 'getFavoriteCompany']),

    menuTab () {
      return [
        {
          text: 'PRODUTOS',
        },
        {
          text: 'VEÍCULOS',
        },
        {
          text: 'CONJ. PEÇAS',
        }
      ]
    },

    areArraysEqual () {
      return JSON.stringify(this.getAllParts) === JSON.stringify(this.getAllRelatedProducts)
    },

    partsPriceRule () {
      return this.selectedPartProducts?.price.find(price => this.quantity >= price.min_limit && this.quantity <= price.max_limit) || {}
    },

    loadingProgress () {
      var percentage = (100 / this.itens.length)
      return percentage
    },

    progressString () {
      let string = parseInt(this.progress)
      return `${string}%`
    },

    lastConfirmedProduct () {
      if (Array.isArray(this.confirmedProducts) && this.confirmedProducts.length > 0) {
        return this.confirmedProducts.at(-1)
      }
      return false
    },

    canShowProductDetail () {
      return this.getSelectedProduct !== null
    },

    partsAddButtonLabel () {
      return this.awaitingCart ? 'Carregando carrinho' : 'Adicionar ao Pedido'
    },

    /** Filtros em drawer em mobile/tablet; coluna lateral no desktop */
    useFilterDrawer () {
      return this.$media.mobile || this.$media.tablet
    },

    /**
     * Botão/painel de filtros aparecem no modo descrição quando há agregações.
     * Depende SÓ de getAggregations (não de getAllProducts.length) porque a
     * action searchProducts limpa os items no início de cada request mas NÃO
     * as agregações — então não há flicker ao aplicar um filtro.
     * Como as agregações persistem, o cache hit também mostra o filtro.
     * Código Scherer não tem filtros, então fica oculto nesse modo.
     */
    canShowFilters () {
      return this.filter === 'descricao' && !!this.getAggregations
    },

    activeFilterCount () {
      return Object.values(this.productFilters).filter(
        v => v != null && String(v).trim() !== ''
      ).length
    },

    activeFilterChips () {
      const chips = []
      Object.keys(this.productFilters).forEach((key) => {
        const val = this.productFilters[key]
        if (val != null && String(val).trim() !== '') {
          chips.push({
            key,
            label: FILTER_FIELD_LABELS[key] || key,
            value: String(val).trim(),
          })
        }
      })
      return chips
    },

  },

  filters: {
    formatCode (value) {
      value = value.toString().split('.0')
      return value[0]
    },
  },

  created () {
    // Travas de execução das buscas (não reativas de propósito — são controle de
    // fluxo, não estado de UI). Uma por superfície de busca: os produtos e os
    // conjuntos de peças têm campos e ciclos de vida independentes.
    this.searchGuard = createSearchGuard()
    this.partsGuard = createSearchGuard()
  },

  async mounted () {
    // Reidrata os checkboxes do filtro a partir do store (sobrevive à troca de rota).
    this.restoreFiltersFromStore()
    // Restaura o estado aberto/minimizado do painel de filtros.
    this.restoreFilterPanelState()

    // Carrega os pedidos ao montar o componente
    await this.handleGetOrderCart()

    // Verifica se deve abrir o modal na inicialização
    if (this.$route.meta.openModal || this.$route.query.openModal === 'parts') {
      setTimeout(() => {
        this.openModal()
      }, 100)
    }

    // Listener global para abrir modal de conj peças
    this.$root.$on('open-parts-modal', () => {
      this.openModal()
    })

    // Listener global para tecla Esc
    window.addEventListener('keydown', this.handleGlobalEscape)
  },

  beforeDestroy () {
    if (this.showFilter) {
      this.$root.$emit('product-filters-close')
    }
    // Remove o listener quando o componente for destruído
    this.$root.$off('open-parts-modal')
    window.removeEventListener('keydown', this.handleGlobalEscape)
    clearTimeout(this.filterDebounceTimer)
  },

  updated () {
    if (this.orders.filter(iten => iten.status === 'Em andamento').length > 0) {
      this.inProgress = true
    }
  },

  methods: {
    ...mapActions(['setHeaderBack', 'setFeedback']),
    ...mapActions('orders', ['addProduct', 'removeStatusTable', 'getOrderCart', 'addPartProducts', 'addNewOrder']),
    ...mapActions('products', ['searchProducts', 'getProduct', 'getPartsProducts', 'selectProduct', 'checkPartsProductPrice', 'getParts', 'getRelatedProducts', 'restoreRelatedProducts', 'removeSelectedParts', 'setFiltersPanelOpen']),

    handleGetPartProducts (searchId) {
      logger.debug('searchID:', searchId)
      return this.getPartProducts.find(item => item.product_id === searchId)
    },

    buildProductFiltersPayload () {
      const out = {}
      const keys = ['grupo_nome', 'grupo_tipo', 'grupo_familia', 'marca_nome', 'linha_nome', 'descricao_curta', 'aumentarRelevancia']
      keys.forEach((k) => {
        const v = this.productFilters[k]
        if (v != null && String(v).trim() !== '') out[k] = String(v).trim()
      })
      return out
    },

    /**
     * Chave que identifica a intenção de busca para a trava de execução.
     * Precisa incluir os filtros: `triggerFilterSearch` re-busca o MESMO termo
     * quando o usuário marca um checkbox, e isso tem que passar pela trava.
     */
    buildSearchKey (search) {
      const term = (search || '').trim().toLowerCase()
      return `${this.filter}|${term}|${JSON.stringify(this.buildProductFiltersPayload())}`
    },

    async handleOrderSearch (search) {
      if (!search || search.trim().length < 3) {
        this.loadingSearch = false
        return
      }

      const normalizedSearch = search.trim().toLowerCase()
      const cachedSearchTerm = this.getLastSearchTerm

      // Termo de busca mudou? Limpa os filtros antes de buscar.
      if (this.filter === 'descricao' && cachedSearchTerm && normalizedSearch !== cachedSearchTerm) {
        this.resetProductFilters()
      }

      // Reusa cache apenas para o input de descricao, sem filtros ativos.
      const cachedProducts = this.getAllProducts
      const hasActiveFilters = this.activeFilterCount > 0

      if (this.filter === 'descricao' && normalizedSearch === cachedSearchTerm && cachedProducts && cachedProducts.length > 0 && !hasActiveFilters) {
        this.loadingSearch = false
        this.productNotFound = false
        // Cache hit conta como busca da sessão — auto-abre o painel na 1ª vez.
        this.autoOpenFiltersOnce()
        return
      }

      // Reusa o produto já carregado quando o mesmo código é buscado novamente.
      if (this.filter === 'codigo' && this.getSelectedProduct && String(this.getSelectedProduct.id) === search.trim()) {
        this.loadingSearch = false
        this.productNotFound = false
        this.openSideBarModal()
        return
      }

      if (this.loadingSearch) return

      // Daqui pra baixo os caches acima não bateram — inclusive quando a busca
      // anterior não achou nada. A trava por chave em runSearch é o que impede
      // a rajada de requests do Enter repetido nesse caso.
      await this.runSearch(search)
    },

    /**
     * Executa a request de busca. Achata os filtros no top-level do payload
     * porque o backend Laravel (`api-tdr`) lê via `$request->grupo_nome` etc.
     */
    async runSearch (search) {
      const key = this.buildSearchKey(search)

      // Trava de execução: mesma chave em voo, ou já concluída dentro do
      // cooldown. Chave diferente (outro termo/tipo/filtro) passa direto.
      if (!this.searchGuard.start(key)) return

      this.loadingSearch = true
      this.productNotFound = false

      // O request cancelado é o único caso em que o loading NÃO é solto no
      // finally: quem controla a UI é o request vencedor, ainda em voo.
      let cancelled = false

      try {
        if (this.filter === 'codigo') {
          const product = await this.getProduct({ search })
          this.productNotFound = product.notFound ?? false
          this.searchGuard.settle(key)

          if (product && !product.notFound) {
            this.openSideBarModal()
          }
          return
        }

        const searchPayload = {
          search,
          type: this.filter,
          ...this.buildProductFiltersPayload(),
        }

        const product = await this.searchProducts(searchPayload)

        // De-dup da API: um request mais novo cancelou este. O request vencedor
        // ainda está em voo e é quem controla loadingSearch/productNotFound —
        // não mexemos em nada aqui pra não apagar o loading antes da hora.
        if (product && product.cancelled) {
          cancelled = true
          this.searchGuard.abort(key)
          return
        }

        this.productNotFound = product.notFound ?? false
        this.searchGuard.settle(key)

        if (!this.productNotFound) {
          this.autoOpenFiltersOnce()
        }

        if (product && !product.notFound) {
          this.openSideBarModal()
        }
      } catch (error) {
        // Sem o try/catch, uma falha de API deixava loadingSearch preso em true
        // e a busca inutilizada até trocar de rota. E o cooldown NÃO é armado
        // aqui de propósito: erro tem que permitir re-tentativa imediata.
        this.searchGuard.abort(key)
        this.setFeedback({
          title: 'Não foi possível concluir a busca',
          message: getUserErrorMessage(error, 'Tente novamente em instantes.'),
          type: 'error',
        })
      } finally {
        if (!cancelled) {
          this.loadingSearch = false
        }
      }
    },

    /** Re-executa a busca usando o último termo, com debounce de 300ms. */
    triggerFilterSearch () {
      if (!this.getLastSearchTerm) return
      clearTimeout(this.filterDebounceTimer)
      this.filterDebounceTimer = setTimeout(() => {
        this.runSearch(this.getLastSearchTerm)
      }, 300)
    },

    resetProductFilters () {
      this.productFilters = {
        grupo_nome: '',
        grupo_tipo: '',
        grupo_familia: '',
        marca_nome: '',
        linha_nome: '',
        descricao_curta: '',
        aumentarRelevancia: '',
      }
    },

    /**
     * Reidrata os checkboxes (productFilters) a partir do que o store guarda em
     * appliedFilters. O Vuex em memória sobrevive à troca de rota, mas o data
     * local do componente é recriado — então ao voltar de outra tela os filtros
     * apareciam vazios mesmo com a lista/agregações já carregadas. Aqui mapeamos
     * o array [{campo, valor}] de volta pro objeto de filtros.
     */
    restoreFiltersFromStore () {
      const applied = this.getAppliedFilters
      if (!Array.isArray(applied) || applied.length === 0) return

      const restored = { ...this.productFilters }
      applied.forEach((f) => {
        if (f && f.campo && Object.prototype.hasOwnProperty.call(restored, f.campo)) {
          restored[f.campo] = f.valor != null ? String(f.valor) : ''
        }
      })
      this.productFilters = restored
    },

    /**
     * Restaura o estado aberto/minimizado do painel ao remontar (volta de rota).
     * Drawer mobile/tablet não reabre sozinho (overlay seria intrusivo ao voltar).
     */
    restoreFilterPanelState () {
      if (this.useFilterDrawer) return
      if (this.getFiltersPanelOpen && this.getAggregations) {
        this.showFilter = true
        // Evita que o auto-open (1ª busca) brigue com o estado já restaurado.
        this.didAutoOpenFilters = true
      }
    },

    /**
     * Abre o painel de filtros automaticamente na 1ª busca da sessão (só desktop).
     * No mobile/tablet o filtro é um drawer overlay — abrir sozinho seria intrusivo.
     *
     * Delay de ~180ms: o painel monta em width:0; setar showFilter=true no mesmo tick
     * faz o Vue aplicar a classe .activated antes do paint inicial e a transition pula
     * direto pra 290px (sem "from"). Os 180ms garantem o paint e dão a sequência visual
     * botão → painel deslizando.
     */
    autoOpenFiltersOnce () {
      if (this.didAutoOpenFilters || this.useFilterDrawer) return
      this.didAutoOpenFilters = true
      setTimeout(() => {
        this.showFilter = true
      }, 180)
    },

    async handleGetOrderCart () {
      // Evita requisições desnecessárias se já existe pedido selecionado e múltiplos pedidos
      if (this.getSelectedOrder && this.orders.length > 1) {
        this.inProgress = this.orders.some(item => item.status === 'Em andamento')
        return
      }

      try {
        if (this.getSelectedOrder && this.orders.length === 1 && this.getSelectedOrder.status === 'Em andamento') {
          await this.getOrderCart({ id: this.getSelectedOrder.id })
        } else {
          await this.getOrderCart()
        }

        // Atualiza o estado de inProgress baseado nos pedidos retornados
        this.inProgress = this.orders.some(item => item.status === 'Em andamento')
      } catch (error) {
        // Precisa do catch para o request ter retorno corretamente.
        // Durante a espera do conjunto de peças (awaitingCart), o
        // handleModalAddProduct já mostra um erro mais detalhado sobre a mesma
        // falha — não duplicar o toast genérico aqui.
        if (!this.awaitingCart) {
          this.setFeedback({ title: 'Não foi possível carregar o carrinho, tente novamente.', message: '', type: 'error' })
        }
      }
    },

    handleOrderFilter (filterValue) {
      // Apenas troca o modo. Os filtros (productFilters) são PRESERVADOS de propósito:
      // ao voltar pra descrição, a lista cacheada e os filtros aplicados reaparecem
      // coerentes (Nível 2). A limpeza de filtros só acontece quando o TERMO muda
      // (tratado em handleOrderSearch). O painel só reabre se já estava aberto, pois
      // showFilter persiste e não chamamos autoOpenFiltersOnce aqui.
      this.filter = filterValue
    },

    async handleSelectProduct (product) {
      if (this.loadingSearch) return
      var search = product.id
      this.loadingSearch = true
      await this.getProduct({
        search,
      }).then((response) => {
        if (response && !response.notFound) {
          this.openSideBarModal()
        }
        if (response && response.notFound) {
          this.setFeedback({ title: 'Produto não encontrado', message: 'Este item não está disponível no momento', type: 'error' })
        }
      }).finally(() => {
        this.loadingSearch = false
      })
    },

    newOrder () {
      this.showModalNewOrder = true
    },

    openSideBarModal () {
      // A barra lateral só existe pra mostrar o detalhe do produto. Sem produto
      // selecionado ela abre vazia — é o que acontecia na busca por descrição,
      // que limpa o selectedProduct (products/searchProducts) e mesmo assim
      // mandava abrir. Em rede lenta o fallback de loading segurava a barra
      // aberta em branco; em rede rápida ela abria e fechava sozinha.
      if (!this.canShowProductDetail) return

      this.showSideBarModal = true
      this.addModalToFocusStack('sideBar')
    },

    closeSideBarModal () {
      this.showSideBarModal = false
      this.removeModalFromFocusStack('sideBar')
    },

    closeSideBarModalWithAnimation () {
      // Chama o método de fechamento com animação da SideBar
      if (this.$refs.sideBar) {
        this.$refs.sideBar.closeWithAnimation()
      }
    },

    async openModal () {
      // Muda para a aba PEÇAS ao invés de abrir o modal
      this.setSelected(2)
      this.showModal = true

      // Se não há produto selecionado, apenas abre a aba para busca
      if (!this.getSelectedProduct) {
        logger.debug('Nenhum produto selecionado, abrindo aba para busca')
        this.visibleTable = 1
        return
      }

      if (this.getSelectedProduct && this.visibleTable === 2) {
        // logger.debug('alterado para produto: ', this.getSelectedProduct.id)
        this.getSelectedParts && logger.debug('conjunto atual: ', this.getSelectedParts?.id)
        // logger.debug('getPartProducts: ', this.getPartProducts)
        let foundProduct = this.getPartProducts.find(product => parseInt(product.set_id) === this.getSelectedParts?.id && parseInt(product.product_id) === this.getSelectedProduct.id)
        // logger.debug('foundProduct: ', foundProduct)
        if (!(Array.isArray(this.getPartProducts) && (foundProduct))) {
          // logger.debug('esse produto NÃO é do mesmo conjunto |', foundProduct?.set_id, this.getSelectedParts?.id, foundProduct?.product_id, this.getSelectedProduct.id)
          this.visibleTable = 1
        } else {
          // logger.debug('esse produto é do mesmo conjunto |', foundProduct?.set_id, this.getSelectedParts?.id, foundProduct?.product_id, this.getSelectedProduct.id)
        }
      }

      if (this.visibleTable === 2) { return }

      if (this.getSelectedProduct) {
        this.loadingTable = true
        this.dados = this.getSelectedProduct.id
        await this.getRelatedProducts({
          search: this.dados,
        })
        this.dados = null
        this.removeSelectedParts()
        this.loadingTable = false
        this.visibleTable = 1
        this.opacity = 1
      }
    },

    closeModal () {
      this.showModal = false
      this.showModalAlert = false
      this.removeOpenModalFromUrl()
      // Volta para a aba de PRODUTOS quando fechar
      this.setSelected(0)
    },

    removeOpenModalFromUrl () {
      if (this.$route.query.openModal === 'parts') {
        this.$router.replace({
          name: this.$route.name,
          query: { ...this.$route.query, openModal: undefined },
        }).catch(() => {
        })
      }
    },

    cancelActionModal () {
      this.$emit('cancelWithoutStock')
    },

    async handlePartsSearch (searchText) {
      if (!searchText) {
        this.restoreRelatedProducts()
        this.lastPartsSearchedKey = null
        this.partsGuard.reset()
        this.loadingParts = false
        return
      }

      this.search = searchText?.toUpperCase()

      if (this.search.length < 3) {
        return
      }

      const normalizedSearch = this.search.trim()

      // Cache: mesmo termo com conjuntos já carregados, não refaz.
      if (normalizedSearch === this.lastPartsSearchedKey && this.getAllParts && this.getAllParts.length > 0) {
        return
      }

      // Trava de execução — cobre o que o cache acima não cobre: request em voo
      // e o termo que já foi buscado e não retornou nenhum conjunto.
      if (this.loadingParts) return
      if (!this.partsGuard.start(normalizedSearch)) return

      this.loadingParts = true
      try {
        await this.removeSelectedParts()
        await this.loadTable({ search: this.search })
        this.lastPartsSearchedKey = normalizedSearch
        this.partsGuard.settle(normalizedSearch)
      } catch (error) {
        // Falha não arma o cooldown: o usuário precisa poder tentar de novo.
        this.partsGuard.abort(normalizedSearch)
        this.setFeedback({
          title: 'Não foi possível buscar os conjuntos',
          message: getUserErrorMessage(error, 'Tente novamente em instantes.'),
          type: 'error',
        })
      } finally {
        this.loadingParts = false
      }
    },

    loadTable (search) {
      return this.getParts(search).then(() => {
        this.visibleTable = 1
      })
    },

    async loadingTableParts () { // NOTE: método carrega os produtos do Conjunto
      this.opacity = 0
      this.loadingTableStock = true
      await this.getPartsProducts({ parts: this.getSelectedParts.id })
        .then(() => {
          this.visibleTable = 2
          this.loadingTableStock = false
          this.handleFeedbackStock()
        })
    },

    handleFeedbackStock () {
      setTimeout(() => {
        if (this.$refs.partsTable?.withoutStock === true) {
          this.setFeedback({ title: 'Não possui alguns produtos disponíveis', message: 'Desculpe, mas não há mais unidades de alguns produtos em estoque.', type: 'error' })
        }
      }, 500)
    },

    handleCloseTable (payload) {
      // this.showModal = false
      // this.removeOpenModalFromUrl()
      this.dados = payload.product_id
      this.handleSelectProduct({ id: payload.product_id })
    },

    async backTable () {
      this.opacity = 1
      this.removeSelectedParts()
      if (this.dados !== null) {
        await this.getRelatedProducts({
          search: this.dados,
        })
        this.dados = null
      }
      this.visibleTable = 1
    },

    askContinueWithoutStock () {
      return new Promise((resolve) => {
        this.showModalAlert = true

        this.$once('confirmWithoutStock', () => {
          this.showModalAlert = false
          resolve(true)
        })

        this.$once('cancelWithoutStock', () => {
          this.showModalAlert = false
          this.visibleTable = 2
          resolve(false)
        })
      })
    },

    // Espera a carga do carrinho em andamento terminar (reaproveitando a request
    // em voo via single-flight; se falhou antes, refaz). Enquanto não assenta,
    // não dá pra saber se já existe pedido — criar agora geraria duplicata.
    async ensureCartSettled () {
      if (this.isLoadingOrderCart || this.getOrderCartError) {
        try {
          await this.getOrderCart()
        } catch (error) {
          // Falha refletida em getOrderCartError; tratada pelo chamador.
        }
      }
      return !this.getOrderCartError
    },

    async handleModalAddProduct () {
      this.loadingProduct = true

      // Aguarda o carrinho assentar antes de inserir. Sem isso, com o
      // carrinho ainda pendente, addConfirmedProductsToCart não enxerga o pedido
      // ativo e cria um novo — o pedido duplicado do chamado.
      this.awaitingCart = true
      const cartReady = await this.ensureCartSettled()
      this.awaitingCart = false
      if (!cartReady) {
        this.setFeedback({
          title: 'Não foi possível carregar o carrinho',
          message: 'Tente novamente para adicionar o conjunto ao pedido.',
          type: 'error',
        })
        this.loadingProduct = false
        return
      }

      this.progress = 0
      this.itens = this.$refs.partsTable.selectProduct

      if (this.$refs.partsTable.withoutStock) {
        const ok = await this.askContinueWithoutStock()
        logger.debug('Usuário escolheu continuar sem estoque:', ok)
        if (!ok) {
          // usuário cancelou → aborta o restante
          this.loadingProduct = false
          return
        }
      }

      // Resetar listas de produtos
      this.pendingProducts = [...this.itens]
      this.confirmedProducts = []
      this.invalidProducts = []

      await this.processProducts()
    },

    async processProducts () {
      this.loadingProgressBar = true
      this.visibleTable = 4

      try {
        const totalProducts = this.pendingProducts.length
        let processedCount = 0

        while (this.pendingProducts.length > 0) {
          logger.debug('Produtos pendentes:', this.pendingProducts)

          const product = this.pendingProducts.shift()
          const shouldContinue = await this.verifyProduct(product)

          // Atualiza o progresso após cada produto processado
          processedCount++
          this.progress = Math.round((processedCount / totalProducts) * 100)
          logger.debug(`Progresso: ${this.progress}%`)

          if (!shouldContinue) {
            // logger.warn('Processamento cancelado pelo usuário')
            this.cancelInsertion()
            return
          }
        }

        if (this.invalidProducts.length > 0) {
          const response = await this.$refs.confirmationModal.show({
            products: this.invalidProducts,
            title: 'Produtos indisponíveis ou não cadastrados',
            message: 'Os seguintes produtos não estão disponíveis para adicionar ao carrinho.',
            messageSubline: 'Deseja adicionar os demais produtos disponíveis ou cancelar a inserção?',
          })
          if (!response) {
            this.cancelInsertion()
            return
          }
        }

        if (this.confirmedProducts.length > 0) {
          await this.addConfirmedProductsToCart()
        } else {
          this.setFeedback({
            title: 'Nenhum produto válido',
            message: 'Todos os produtos selecionados estão indisponíveis ou não cadastrados.',
            type: 'error',
          })
          this.finishInsertion(false)
        }
      } catch (error) {
        logger.error('Erro no processamento:', error)
        this.setFeedback({
          title: 'Erro no processamento',
          message: 'Ocorreu um erro ao processar os produtos',
          type: 'error',
        })
      } finally {
        this.loadingProgressBar = false
        this.visibleTable = 0
        this.showModal = false
        this.removeOpenModalFromUrl()
        this.loadingProduct = false
      }
    },

    async verifyProduct (product) {
      try {
        const productPrice = await this.checkPartsProductPrice({ id: product })
        const productData = this.getSelectedParts.products.find(p => p.id === product)
        logger.debug('productPrice:', productPrice)

        const hasValidPrice = this.validPrice(productData, productPrice)
        logger.debug('hasValidPrice:', hasValidPrice)

        if (!productData || productData.id === 0 || !hasValidPrice) {
          const productInfo = this.handleGetPartProducts(product)
          this.invalidProducts.push({
            product_id: product,
            description: productInfo?.description ?? `Produto ${product}`,
          })
          return true
        } else {
          // Produto válido, adiciona normalmente
          this.confirmedProducts.push(productData)
        }

        return true
      } catch (error) {
        return false
      }
    },

    validPrice (productData, productPrice) {
      productData.quantity = this.getPartProducts.find(item => item.product_id === productData.id)?.quantity ?? 0

      // Atualiza para utilizar a computed
      this.selectedPartProducts = productData

      const applicableRule = Array.isArray(productPrice) && productPrice.length > 0
        ? productPrice.find(rule => productData.quantity >= (rule?.min_limit ?? 0) && productData.quantity <= (rule?.max_limit ?? 999999))
        : null

      const hasValidPrice = applicableRule != null && applicableRule.price != null && Number(applicableRule.price) > 0
      return hasValidPrice
    },

    async addConfirmedProductsToCart () {
      this.loadingProgressBar = true
      this.visibleTable = 5

      // Verifica se existe um pedido selecionado, se não, cria automaticamente
      if (!this.getSelectedOrder) {
        logger.debug('Nenhum pedido selecionado, criando automaticamente...')

        const orderCreated = await this.ensureOrderExists()

        if (!orderCreated) {
          this.finishInsertion(false)
          return
        }

        // Aguarda até que o pedido seja criado e selecionado (máximo 10 tentativas)
        let attempts = 0
        const maxAttempts = 10
        while (!this.getSelectedOrder && attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, 200))
          attempts++
          logger.debug(`Tentativa ${attempts}/${maxAttempts} - Aguardando pedido...`)
        }

        // Verifica se agora existe um pedido selecionado
        if (!this.getSelectedOrder) {
          logger.error('Falha ao criar pedido automático após todas as tentativas')
          this.finishInsertion(false)
          return
        }

        logger.debug('Pedido criado e selecionado com sucesso, continuando...')
      }

      // verifica bloqueio em lote
      const { ok, errors } = this.checkBlockSaleBatch(this.confirmedProducts)

      // se tiver erros, exibe e cancela inserção
      if (errors.length) {
        errors.forEach(e => {
          this.setFeedback({
            title: `Produto ${e.product.id}`,
            message: e.message,
            type: 'error',
          })
        })
        this.finishInsertion(false)
        return
      }

      // se tudo ok, envia o lote aprovado
      await this.addPartProductsToOrder(ok)
    },

    async addPartProductsToOrder (products) {
      try {
        const { okProducts, failedEntries } = await this.addPartProducts(products)
        logger.debug('Inseridos com sucesso:', okProducts)
        if (failedEntries.length === 0) {
          this.finishInsertion(true)
        } else {
          this.setFeedback({
            title: 'Alguns produtos não puderam ser adicionados',
            message: `${failedEntries.length} produto(s) falharam na inserção`,
            type: 'error',
          })
          this.finishInsertion(false)
        }

        return true
      } catch (error) {
        logger.error('Erro na inserção em lote:', error)
        this.setFeedback({
          title: 'Erro ao adicionar produtos',
          message: getUserErrorMessage(error, 'Não foi possível adicionar os produtos ao carrinho'),
          type: 'error',
        })
        this.finishInsertion(false)
        return false
      }
    },

    cancelInsertion () {
      this.pendingProducts = []
      this.confirmedProducts = []
      this.invalidProducts = []
      this.loadingProduct = false
      this.loadingProgressBar = false
      this.setFeedback({
        title: 'Inserção cancelada',
        message: 'Os produtos não cadastrados foram removidos do processo',
        type: 'error',
      })
    },

    finishInsertion (showSuccessMessage = false) {
      this.loadingProgressBar = false
      this.showModal = false
      this.visibleTable = 0
      this.invalidProducts = []
      this.removeOpenModalFromUrl()
      // Volta para a aba de PRODUTOS após finalizar
      this.setSelected(0)
      if (showSuccessMessage) {
        this.setFeedback({
          title: 'Produtos adicionados com sucesso',
          message: '',
          type: 'success',
        })
      }
    },

    checkBlockSaleBatch (products) {
      logger.debug('Iniciando checkBlockSaleBatch para produtos:', products)

      const blockMode = this.getBlockSale
      const favoriteId = this.getFavoriteCompany

      const ok = []
      const errors = []

      for (const prod of products) {
        const qtd = prod.quantity || 0
        const stockPref = prod.stock.find(stock => stock.company_id === favoriteId)?.quantity || 0
        const total = prod.stock.reduce((total, stock) => total + (stock.quantity || 0), 0)

        switch (blockMode) {
          case 0:
            ok.push(prod)
            break

          case 1:
            if (qtd > total) {
              errors.push({ product: prod, message: 'Sem estoque em todo o estado' })
            } else {
              ok.push(prod)
            }
            break

          case 2:
            if (qtd > stockPref) {
              errors.push({ product: prod, message: 'Sem estoque na filial preferencial' })
            } else {
              ok.push(prod)
            }
            break

          default:
            errors.push({ product: prod, message: `Problema na verifição de venda` })
        }
      }

      return { ok, errors }
    },

    totalStockQuantity (product) {
      return product?.stock.reduce(
        (total, stock) => total + stock.quantity,
        0
      )
    },
    stockFavoriteCompany (product) {
      return product?.stock.find(stock => stock.company_id === this.getFavoriteCompany)
    },

    setSelected (tab) {
      this.selected = tab
    },

    hasValidStock (products) {
      return Array.isArray(products) && products.length > 0 && products.some(product => this.hasStock(product))
    },
    hasStock (product) {
      return product && Array.isArray(product.stock) && product.stock.length > 0
    },

    // Verifica e cria um pedido quando necessário
    async ensureOrderExists () {
      if (this.inProgress) {
        return // Já existe um pedido em andamento
      }

      try {
        const defaultOrderData = {
          name: '',
          obs: '',
        }

        await this.addNewOrder(defaultOrderData)

        this.inProgress = true

        // Recarrega o carrinho para garantir que o novo pedido seja selecionado
        await this.handleGetOrderCart()

        this.setFeedback({
          title: 'Pedido criado automaticamente',
          message: 'Um novo pedido foi criado para adicionar produtos',
          type: 'success',
        })

        return true
      } catch (error) {
        logger.error('Erro ao criar pedido', error)
        this.setFeedback({
          title: 'Erro ao criar pedido',
          message: 'Não foi possível criar um pedido automaticamente',
          type: 'error',
        })
        return false
      }
    },

    // Métodos para gerenciar o foco dos modais
    addModalToFocusStack (modalName) {
      this.removeModalFromFocusStack(modalName)
      this.modalFocusStack.push(modalName)
    },

    removeModalFromFocusStack (modalName) {
      const index = this.modalFocusStack.indexOf(modalName)
      if (index > -1) {
        this.modalFocusStack.splice(index, 1)
      }
    },

    getTopModal () {
      return this.modalFocusStack.length > 0 ? this.modalFocusStack[this.modalFocusStack.length - 1] : null
    },

    isModalInFocus (modalName) {
      return this.getTopModal() === modalName
    },

    handleEscapeKey () {
      if (this.selected === 0 && this.showFilter) {
        this.showFilter = false
        return
      }
      // Método centralizado para lidar com a tecla Esc
      const topModal = this.getTopModal()

      if (topModal === 'sideBar') {
        this.closeSideBarModal()
      } else if (this.selected === 2) {
        // Se estiver na aba PEÇAS, volta para PRODUTOS
        this.closeModal()
      }
    },

    handleGlobalEscape (event) {
      if (event.keyCode === 27 || event.key === 'Escape') {
        this.handleEscapeKey()
      }
    },

    handleOpenPartsProductsFromSideBar () {
      this.closeSideBarModalWithAnimation()

      setTimeout(() => {
        this.openModal()
      }, 100)
    },

    handleConfirmWithoutStock () {
      this.showModalAlert = false
      this.$emit('confirmWithoutStock')
    },

    handleUpdateFilters (filters) {
      this.productFilters = { ...filters }
      this.triggerFilterSearch()
    },

    removeFilterChip (key) {
      this.productFilters = { ...this.productFilters, [key]: '' }
      this.triggerFilterSearch()
    },

    clearAllProductFilters () {
      this.resetProductFilters()
      this.triggerFilterSearch()
    },

    closeFilterDrawer () {
      this.showFilter = false
    },

    toggleFilters () {
      this.showFilter = !this.showFilter
    },
  },

  watch: {
    showModal (newValue) {
      if (this.getstatusTable === true) {
        this.removeStatusTable()
        this.visibleTable = 0
      }

      if (!newValue && this.$route.query.openModal === 'parts') {
        this.removeOpenModalFromUrl()
      }
    },
    $route () {
      if (this.$route.meta.openModal || this.$route.query.openModal === 'parts') {
        // Aguarda para garantir que o componente esteja carregado
        setTimeout(() => {
          this.openModal()
        }, 100)
      }
    },
    visibleTable (newValue) {
      logger.debug('visibleTable mudou para:', newValue)
    },

    showFilter (val) {
      // Persiste o estado aberto/minimizado no store (em memória) p/ restaurar
      // ao voltar de outra rota.
      this.setFiltersPanelOpen(val)
      if (val) {
        this.$root.$emit('product-filters-open')
      } else {
        this.$root.$emit('product-filters-close')
      }
    },
  },
}
</script>

<template>
  <div :class="$classes['search-content']">
    <div :class="$classes['header']">
      <span :class="$classes['search-title']">Pesquisas</span>
      <div :class="$classes['header-buttons']">
        <action variant="outlined" v-if="!$media.mobile" color="secondary" :class="$classes['header-btn']"
          @click="newOrder">
          <icon name="clipboard-list" btnIcon />Iniciar Novo Pedido
        </action>
        <action variant="outlined" v-if="$media.mobile" mobile color="secondary" :class="$classes['header-btn']"
          @click="newOrder">
          <icon name="clipboard-list" btnIcon />Novo Pedido
        </action>
      </div>
    </div>
    <div :class="$classes['main-content']" data-results-bounds>
      <TabNav :tabs="menuTab" :selected="selected" @selected="setSelected" :class="$classes['tab-label']">
        <Tab :isSelected="selected === 0" :class="{ selectedTab: selected === 0 }">
          <div :class="{ [$classes['selected-tab']]: true }">
            <div v-if="showFilter && useFilterDrawer && canShowFilters" :class="$classes['filter-drawer-overlay']"
              role="dialog" aria-modal="true" aria-label="Filtros de produtos" @click.self="closeFilterDrawer">
              <div :class="$classes['filter-drawer-panel']" @click.stop>
                <div :class="$classes['filter-drawer-body']">
                  <product-filters :filters="productFilters" :aggregations="getAggregations" show-close
                    @update-filters="handleUpdateFilters" @close="closeFilterDrawer" />
                </div>
              </div>
            </div>

            <div :class="$classes['products']">
              <div :class="$classes['products-layout']">
                <div :class="$classes['products-main']">
                  <div :class="$classes['content-body']">
                    <div v-if="!useFilterDrawer" :class="{
                      [$classes['disable-filter-bar']]: true,
                      [$classes['activated']]: showFilter && canShowFilters,
                    }">
                      <div v-if="showFilter && canShowFilters" :class="$classes['filter-animate']">
                        <product-filters :filters="productFilters" :aggregations="getAggregations"
                          @update-filters="handleUpdateFilters" />
                      </div>
                    </div>

                    <div :class="$classes['main-content']">
                      <div :class="$classes['content']">
                        <base-card>
                          <div :class="$classes['search-wrapper']">
                            <filter-search placeholder="Escreva aqui" :filters="filters"
                              :default-value="filters[0].value" :results="getAllProducts" :loading="loadingSearch"
                              :product-not-found="productNotFound" @search="handleOrderSearch"
                              @filter="handleOrderFilter" @select="handleSelectProduct" :disable="false"
                              :current-filter="filter">
                              <template #before-filter-type>
                                <action v-if="canShowFilters" variant="flat" color="secondary" type="button" :class="[
                                  $classes['filter-toggle-btn'],
                                  { [$classes['filter-toggle-active']]: showFilter },
                                ]" :title="showFilter ? 'Ocultar painel de filtros' : 'Abrir filtros'"
                                  :aria-label="showFilter ? 'Ocultar painel de filtros' : 'Abrir filtros'"
                                  @click="toggleFilters">
                                  <icon name="filter-horizontal" btnIcon />
                                  <span :class="$classes['filter-toggle-label']">Filtros</span>
                                  <span v-if="activeFilterCount > 0" :class="$classes['filter-badge']">{{
                                    activeFilterCount
                                  }}</span>
                                </action>
                              </template>
                              <template #before-results>
                                <div v-if="canShowFilters && activeFilterChips.length"
                                  :class="$classes['filter-chips-row']">
                                  <span :class="$classes['filter-applied-label']">Aplicados:</span>
                                  <div :class="$classes['filter-chips']">
                                    <button v-for="chip in activeFilterChips" :key="chip.key" type="button"
                                      :class="$classes['filter-chip']" @click="removeFilterChip(chip.key)">
                                      <span :class="$classes['filter-chip-text']">{{ chip.label }}: {{ chip.value
                                      }}</span>
                                      <icon name="times" noMargin :class="$classes['filter-chip-remove']" />
                                    </button>
                                  </div>
                                  <button type="button" :class="$classes['clear-all-filters']"
                                    @click="clearAllProductFilters">
                                    Limpar tudo
                                  </button>
                                </div>
                              </template>
                            </filter-search>
                          </div>
                        </base-card>
                        <!-- <product-detail v-if="canShowProductDetail" @open="openModal" @ensureOrderExists="ensureOrderExists"
                      ref="productDetail" /> -->
                        <!-- O carrinho tem indicador próprio na coluna lateral e não pode
                             bloquear a área de busca: os resultados devem aparecer mesmo
                             com o carrinho ainda pendente. -->
                        <content-loading v-if="loadingSearch || loadingCart"></content-loading>
                        <no-results-message v-else-if="productNotFound && !canShowProductDetail"
                          :title="'Não encontramos resultados para a sua busca.'"
                          :message="'Tente usar palavras-chave diferentes ou mais genéricas'" />
                        <no-results-message
                          v-else-if="hasLoadedOrderCart && orders.length === 0 && !getSelectedProduct && !loadingSearch"
                          img="clipboard-list" :iconWidth="'64px'" :title="'Busque produtos ou inicie um pedido.'"
                          :message="'Você pode buscar produtos diretamente ou criar um novo pedido para começar'" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Durante a carga inicial `orders` está vazio; sem isso a coluna do
                     carrinho nem existe no DOM e o skeleton não tem onde renderizar. -->
                <aside v-if="orders.length > 0 || isLoadingOrderCart || getOrderCartError"
                  :class="$classes['cart-column']">
                  <order-cart :loading.sync="loadingCart" @changeTab="selected = $event"
                    @openSideBarModal="openSideBarModal" />
                </aside>
              </div>
            </div>
          </div>
        </Tab>
        <Tab :isSelected="selected === 1">
          <div :class="{ [$classes['selected-tab']]: true }">
            <VehiclePlateSearch @openSideBarModal="openSideBarModal" @productNotFound="productNotFound = $event">
            </VehiclePlateSearch>
          </div>
        </Tab>
        <Tab :isSelected="selected === 2">
          <div :class="{ [$classes['selected-tab']]: true, [$classes['pecas-tab']]: true }">
            <div :class="$classes['pecas-content']">
              <!-- Header Section -->
              <div v-show="visibleTable !== 4 && visibleTable !== 5" :class="$classes['pecas-header']">
                <!-- Actions Bar -->
                <div v-if="visibleTable === 2" :class="$classes['pecas-actions-bar']">
                  <action variant="flat" color="secondary" uppercase :class="$classes['pecas-back-btn']"
                    @click="backTable">
                    <icon name="long-arrow-alt-left" btnIcon :class="$classes['order-back-btn-icon']" />
                    Voltar
                  </action>
                  <action :disabled="!getBoolSelectedPartsProducts || loadingProduct" variant="contained"
                    color="primary" :class="$classes['pecas-add-btn']" :loading="loadingProduct"
                    @click="handleModalAddProduct">
                    <icon v-if="!awaitingCart" name="plus" btnIcon />
                    {{ partsAddButtonLabel }}
                  </action>
                </div>

                <!-- Search Bar -->
                <div v-if="visibleTable < 3" :class="$classes['pecas-search-wrapper']">
                  <filter-search :class="$classes['pecas-search']"
                    placeholder="Digite uma descrição para buscar conjuntos de peças..." @search="handlePartsSearch"
                    :loading="loadingParts" outlined />
                </div>
                <!-- Info Section -->
                <div v-if="visibleTable !== 0 && visibleTable !== 3 && visibleTable !== 4 && visibleTable !== 5"
                  :class="$classes['pecas-info-card']">
                  <div v-if="visibleTable === 1 && (getAllRelatedProducts.length > 0)"
                    :class="$classes['pecas-info-content']">
                    <div v-if="getSelectedProduct && areArraysEqual" :class="$classes['pecas-info-text']">
                      <div :class="$classes['pecas-info-badge']">
                        <icon name="info-circle" :class="$classes['pecas-info-icon']" />
                        <span>Conjunto relacionado</span>
                      </div>
                      <span :class="$classes['pecas-info-label']">Código:</span>
                      <span :class="$classes['pecas-info-value']">{{ getSelectedProduct.id }}</span>
                    </div>
                  </div>
                  <div v-else-if="JSON.stringify(getSelectedParts) !== '{}'" :class="$classes['pecas-info-content']">
                    <div :class="$classes['pecas-info-text']">
                      <div :class="$classes['pecas-info-badge']">
                        <icon name="settings" :class="$classes['pecas-info-icon']" />
                        <span>Itens do Conjunto</span>
                      </div>
                      <span :class="$classes['pecas-info-label']">Código:</span>
                      <span :class="$classes['pecas-info-value']">{{ getSelectedParts.id }}</span>
                    </div>
                    <div :class="$classes['pecas-info-description']">
                      {{ getSelectedParts.description }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading States -->
              <div v-if="visibleTable === 4 || visibleTable === 5" :class="$classes['pecas-loading-card']">
                <div :class="$classes['pecas-loading-content']">
                  <div :class="$classes['pecas-loading-header']">
                    <div :class="$classes['pecas-loading-spinner']"></div>
                    <span :class="$classes['pecas-loading-text']">
                      <span v-if="visibleTable === 4">Verificando produtos</span>
                      <span v-else>Adicionando produtos</span>
                      <span :class="$classes['dots']"></span>
                    </span>
                  </div>
                  <div v-if="lastConfirmedProduct" :class="$classes['pecas-loading-item']">
                    <span :class="$classes['pecas-loading-item-code']">{{ lastConfirmedProduct.id }}</span>
                    <span :class="$classes['pecas-loading-item-desc']">{{ lastConfirmedProduct.description }}</span>
                  </div>
                  <progress-bar :val="progress" :text="progressString" :title="progressString" v-if="loadingProgressBar"
                    :class="$classes['pecas-progress-bar']" />
                </div>
              </div>

              <!-- Main Content Body -->
              <div v-show="visibleTable !== 4 && visibleTable !== 5" :class="$classes['pecas-body']">
                <!-- Subtitle Message (only when visibleTable === 0) -->
                <div v-if="visibleTable === 0" :class="$classes['pecas-subtitle-container']">
                  <icon name="not-found" :class="$classes['pecas-empty-icon']" />
                  <h3 :class="$classes['pecas-subtitle-title']">Buscar Conjuntos de Peças</h3>
                  <p :class="$classes['pecas-subtitle-text']">
                    Busque e selecione conjuntos de peças para adicionar ao seu carrinho
                  </p>
                </div>

                <!-- Loading State -->
                <div v-else-if="loadingTable || loadingParts" :class="$classes['pecas-loading-state']">
                  <content-loading :height="'200px'"></content-loading>
                </div>

                <!-- Table State 1: List of Parts Sets -->
                <div v-else-if="visibleTable === 1 && getAllParts.length != 0" :class="$classes['pecas-table-wrapper']">
                  <Table @newTable="loadingTableParts" :filter="'selectedParts'" :visibleCheck="false"
                    :content="getAllParts" :titles="{
                      id: { title: 'Código' },
                      description: { title: 'Descrição' },
                    }"></Table>
                </div>

                <!-- Empty State -->
                <div v-else-if="visibleTable === 1 && getAllParts.length === 0" :class="$classes['pecas-empty-state']">
                  <icon name="blocked-box" :class="$classes['pecas-notfound-icon']" />
                  <h3 :class="$classes['pecas-empty-title']">Nenhum conjunto encontrado</h3>
                  <p :class="$classes['pecas-empty-text']">
                    O código do produto selecionado não possui conjuntos relacionados.
                  </p>
                </div>

                <!-- Table State 2: Products in Set -->
                <div v-else-if="visibleTable === 2" :class="$classes['pecas-table-wrapper']">
                  <div v-if="loadingTableStock" :class="$classes['pecas-loading-state']">
                    <content-loading :height="'200px'"></content-loading>
                  </div>
                  <Table v-else-if="hasValidStock" ref="partsTable" :filter="'selectedParts'"
                    @closeTable="handleCloseTable($event)" :visibleCheck="true" :content="getPartProducts" :titles="{
                      product_id: { title: 'Produto' },
                      quantity: { title: 'Qtd' },
                      industry_id: { title: 'Indústria' },
                      description: { title: 'Descrição' },
                    }"></Table>
                </div>

              </div>
            </div>
            <modal-confirmation-pecas ref="confirmationModal" />
          </div>
        </Tab>
      </TabNav>
      <!-- Modal de Aviso de Estoque -->
      <modal-pecas :active="showModalAlert" @close="cancelActionModal" :alert="true" :visible="3" :close="false">
        <template v-slot:header>
          <modal-header title="Aviso" />
        </template>
        <template v-slot:body>
          <div :class="$classes['pecas-alert-modal-content']">
            <div :class="$classes['pecas-alert-text']">
              <p :class="$classes['pecas-alert-message']">
                Nem todos os produtos do conjunto de peças estão em estoque.
              </p>
              <p :class="$classes['pecas-alert-question']">
                Deseja continuar mesmo assim?
              </p>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <div :class="$classes['pecas-alert-actions']">
            <action variant="flat" color="secondary" uppercase bold @click="cancelActionModal"
              :class="$classes['pecas-alert-cancel-btn']">
              <icon v-if="!$media.mobile" name="long-arrow-alt-left" btnIcon />
              Cancelar
            </action>
            <action variant="contained" color="primary" :loading="loading" :disabled="loading"
              @click="handleConfirmWithoutStock" :class="$classes['pecas-alert-confirm-btn']">
              Confirmar
            </action>
          </div>
        </template>
      </modal-pecas>
      <modal-new-order :active.sync="showModalNewOrder" />
      <side-bar :active="showSideBarModal" @close="closeSideBarModal" ref="sideBar"
        :is-in-focus="isModalInFocus('sideBar')">
        <template v-slot:body>
          <product-detail v-if="canShowProductDetail" @ensureOrderExists="ensureOrderExists" ref="productDetail"
            @closeSideBarModal="closeSideBarModal" @closeSideBarModalWithAnimation="closeSideBarModalWithAnimation"
            @openPartsProductsFromSideBar="handleOpenPartsProductsFromSideBar" />

          <!-- Só o carregamento do PRODUTO entra aqui. O carrinho (isLoadingOrderCart)
               é independente da barra lateral e mantinha um spinner eterno quando a
               busca terminava antes do carrinho. -->
          <content-loading v-else-if="loadingSearch || loadingCart"></content-loading>
        </template>
      </side-bar>
    </div>
  </div>
</template>

<style module>
.products {
  padding: 45px 0px 30px 0px;
}

.products-layout {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  max-width: 100%;
}

.products-main {
  flex: 1;
  width: 100%;
  min-width: 0;
}

.cart-column {
  flex: 0 0 342px;
  width: 342px;
  max-width: 100%;
  position: sticky;
  top: 88px;
  align-self: flex-start;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 2;
}

.selected-tab {
  background-color: #f3f3f4;
}

.tab-label {
  font-size: 18px;
  color: #292929;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  width: -webkit-fill-available;
}

.notification-label {
  align-self: center;
  margin: 16px;
  width: 300px;
}

.product-addOrder-btn {
  height: 40px;
  padding: 0 15px;
  float: right;
}

.product-detail {
  margin-top: 30px;
}

.product-info-content {
  margin-top: 2rem;
  padding: 40px;
  text-align: center;
  width: auto;
  height: auto;
  background-color: white;
  border-radius: 10px;
}

.product-info-label {
  /* display: block; */
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #292929;
  visibility: hidden;
  margin-bottom: 10px;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}

.product-info-label.show {
  visibility: visible;
  opacity: 1;
}

.product-info-label.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-info-label .label-color {
  color: #4a94d4;
}

.product-info-label-alert {
  display: block;
  text-transform: initial;
  font-size: 14px;
  line-height: 18px;
  color: #292929;
  margin-bottom: 10px;
}

.product-info-label-alert .label-color {
  color: #4a94d4;
}

.product-info-label-alert.not-found {
  color: #333333;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin: 20px 20px 10px 20px;
  line-height: 1.5;
}

.product-stock-actions-alert {
  margin-top: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 3px;
}

.icon-wrapper.not-found {
  width: auto;
  height: 7rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-title {
  text-transform: uppercase;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #292929;
}

.content-body {
  display: flex;
  width: -webkit-fill-available;
  flex-wrap: nowrap;
}

.disable-filter-bar {
  display: flex;
  visibility: hidden;
  transition: width 0.6s;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding: 0;
  width: 0px;
  overflow: hidden;
  will-change: width;
}

.disable-filter-bar.activated {
  display: flex;
  visibility: visible;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
  transition: width 0.6s;
  width: 290px;
  overflow: visible;
  padding-right: 16px;
}

.filter-animate {
  width: 100%;
  animation-name: animateIn;
  animation-duration: 200ms;
  animation-timing-function: ease-in-out;
  animation-delay: 0ms;
  animation-fill-mode: both;
}

@keyframes animateIn {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }

  100% {
    opacity: 1;
  }
}

.main-content {
  display: flex;
  flex: 1;
  justify-content: space-between;
  width: inherit;
}

.content {
  flex: 1;
  /* margin-right: 25px; */
}

.search-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

/* Botão "Filtros" — V1 "Ink Outline" (paleta escura neutra do design system).
   Sobrescreve o peso visual padrão do Action (flat/secondary) via !important.
   Default: card branco + borda cinza-média + texto grafite.
   Ativo (painel aberto): preenchido preto. */
.filter-toggle-btn {
  white-space: nowrap;
  flex-shrink: 0;
  gap: 8px;
  border-radius: 8px;
  min-height: 36px;
  height: auto;
  padding: 8px 14px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
  color: #292929 !important;
  background: #ffffff !important;
  border: 1px solid #c7c7c7 !important;
  position: relative;
  transition: background-color 180ms cubic-bezier(.2, .7, .3, 1),
    border-color 180ms cubic-bezier(.2, .7, .3, 1),
    color 180ms cubic-bezier(.2, .7, .3, 1),
    box-shadow 180ms cubic-bezier(.2, .7, .3, 1),
    transform 180ms cubic-bezier(.2, .7, .3, 1);
}

.filter-toggle-btn:hover {
  background: #f8f8f9 !important;
  color: #292929 !important;
  border-color: #5c5c5c !important;
}

.filter-toggle-btn:focus-visible {
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 3px rgba(26, 26, 26, 0.18);
  border-color: #1a1a1a !important;
}

.filter-toggle-btn:active {
  transform: translateY(0.5px);
}

.filter-toggle-label {
  margin-left: 0;
}

.filter-toggle-btn svg {
  width: 16px;
  height: 16px;
  margin-right: 0;
  flex-shrink: 0;
}

/* Estado ativo (painel aberto) = preenchido escuro */
.filter-toggle-active {
  color: #ffffff !important;
  background: #1a1a1a !important;
  border-color: #1a1a1a !important;
}

.filter-toggle-active:hover {
  color: #ffffff !important;
  background: #292929 !important;
  border-color: #292929 !important;
}

.filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 4px;
  padding: 0 6px;
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
  background: #1a1a1a;
  border-radius: 999px;
  line-height: 1;
}

/* No estado ativo o badge inverte: fundo branco, texto escuro */
.filter-toggle-active .filter-badge {
  background: #ffffff;
  color: #1a1a1a;
}

.filter-chips-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  padding: 0px 4px;
  width: 100%;
}

.filter-applied-label {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  color: #6c757d;
}

.filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  min-width: 220px;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 6px 10px;
  font-size: 12px;
  color: #292929;
  background: #FDF2F2;
  border: 1px solid rgba(209, 64, 64, 0.35);
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.filter-chip:hover {
  background: #FADADA;
}

.filter-chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 240px;
}

.filter-chip-remove {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  opacity: 0.7;
}

.clear-all-filters {
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-decoration: underline;
  cursor: pointer;
}

.clear-all-filters:hover {
  color: #D14040;
}

.filter-drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 95;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  padding: 0;
}

.filter-drawer-panel {
  width: min(100vw, 400px);
  max-width: 100%;
  height: 100%;
  background: #f3f3f4;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.filter-drawer-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 0 24px;
}

.search-content {
  padding: 25px 45px 0px 45px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-title {
  /* font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: #292929;
}

@media (max-width: 1280px) {
  .products-layout {
    flex-direction: column;
  }

  .cart-column {
    position: relative;
    top: auto;
    flex: 1 1 auto;
    width: 100%;
    max-height: none;
    align-self: stretch;
  }
}

.pecas-tab {
  padding: 25px 0px 45px 0px;
  /* background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); */
  min-height: calc(100vh - 205px);
}

.pecas-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
}

/* Header Section */
.pecas-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  padding: 14px 18px;
}

.pecas-subtitle {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
}

.pecas-subtitle-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  padding: 40px 20px;
  text-align: center;
}

.pecas-subtitle-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 10px 0;
  text-align: center;
}

.pecas-subtitle-text {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.5;
  max-width: 500px;
  margin: 0;
}

/* Modal de Alerta */
.pecas-alert-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* Actions Bar */
.pecas-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.pecas-back-btn {
  transition: all 0.3s ease;
  border-radius: 4px;
  padding: 10px;
  font-weight: 600;
}

.pecas-add-btn {
  border-radius: 4px;
  padding: 10px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.pecas-add-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(74, 148, 212, 0.3);
}

/* Search Wrapper */
.pecas-search-wrapper {
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  border: none;
  transition: all 0.3s ease;
}

.pecas-search {
  margin: 0;
}

/* Info Card */
.pecas-info-card {
  border-radius: 4px;
  transition: all 0.3s ease;
}

.pecas-info-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 0px;
}

.pecas-info-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(74, 148, 212, 0.1);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #4A94D4;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  width: fit-content;
  border: 1px solid rgba(74, 148, 212, 0.2);
}

.pecas-info-icon {
  width: 16px;
  height: 16px;
  color: #4A94D4;
}

.pecas-info-text {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pecas-info-label {
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.pecas-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #4A94D4;
  font-family: monospace;
  padding: 4px 8px;
  background: rgba(74, 148, 212, 0.1);
  border-radius: 4px;
}

.pecas-info-description {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  margin-top: 6px;
  padding: 10px 14px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #4A94D4;
}

/* Loading Card */
.pecas-loading-card {
  padding: 32px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.pecas-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.pecas-loading-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.pecas-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(74, 148, 212, 0.1);
  border-top-color: #4A94D4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.pecas-loading-text {
  font-size: 16px;
  font-weight: 600;
  color: #4A94D4;
  text-align: center;
}

.pecas-loading-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: rgba(74, 148, 212, 0.05);
  border-radius: 4px;
  border: 1px solid rgba(74, 148, 212, 0.15);
  min-width: 300px;
  min-height: 200px;
}

.pecas-loading-item-code {
  font-size: 18px;
  font-weight: 700;
  color: #4A94D4;
  font-family: 'Courier New', monospace;
}

.pecas-loading-item-desc {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
}

.pecas-progress-bar {
  width: 100%;
  max-width: 400px;
}

/* Body Section */
.pecas-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  min-height: 400px;
}

.pecas-body:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.pecas-loading-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

/* Table Wrapper */
.pecas-table-wrapper {
  /* Tabela já tem seus próprios estilos do componente Table */
  display: block;
}

/* Empty State */
.pecas-empty-state {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  text-align: center;
}

.pecas-empty-icon {
  width: 150px;
  height: auto;
  /* color: #dee2e6; */
  /* margin-bottom: 16px; */
  opacity: 0.6;
}

.pecas-notfound-icon {
  width: 100px;
  height: auto;
  /* color: #dee2e6; */
  margin-bottom: 16px;
  opacity: 0.6;
}

.pecas-empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 10px 0;
  text-align: center;
}

.pecas-empty-text {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.5;
  max-width: 500px;
  margin: 0;
}

.pecas-alert-icon-wrapper {
  display: flex;
  justify-content: center;
}

.pecas-alert-icon {
  width: 48px;
  height: 48px;
  color: #ff9800;
}

.pecas-alert-text {
  text-align: center;
}

.pecas-alert-message {
  font-size: 14px;
  /* color: #856404; */
  margin: 0 0 8px 0;
  line-height: 1.5;
}

.pecas-alert-question {
  font-size: 14px;
  font-weight: 600;
  /* color: #856404; */
  margin: 0;
}

.pecas-alert-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 55px;
  flex-wrap: wrap;
}

.pecas-alert-cancel-btn,
.pecas-alert-confirm-btn {
  padding: 10px;
  font-weight: 600;
  border-radius: 4px;
  min-width: 140px;
}

.order-back-btn-icon {
  margin-right: 8px;
}

.loading-dots .dots::after {
  content: '';
  animation: dots 1.2s steps(4, end) infinite;
}

@keyframes dots {
  0% {
    content: '';
  }

  25% {
    content: '.';
  }

  50% {
    content: '..';
  }

  75% {
    content: '...';
  }

  100% {
    content: '';
  }
}

@media (max-width: 1280px) {
  .products {
    padding-bottom: 100px;
  }

  .selected-tab {
    background-color: #f3f3f4;
    margin-right: 0px;
  }

  .content {
    margin-right: 0;
  }

  .cart-column {
    position: fixed;
    top: auto;
    bottom: 10px;
    right: 10px;
    left: auto;
    width: min(342px, calc(100vw - 20px));
    /* max-height: min(50vh, 400px); */
    z-index: 89;
  }

  .pecas-tab {
    padding: 25px 0px 45px 0px;
  }

  .pecas-content {
    gap: 20px;
  }

  .pecas-main-title {
    font-size: 24px;
  }

  .pecas-body {
    padding: 12px 0;
    border-radius: 4px;
  }
}

@media (max-width: 1024px) {
  .filter-drawer-body {
    padding: 0 0 0 0;
  }
}

@media (max-width: 767px) {
  .search-content {
    padding: 10px;
    margin-bottom: 55px;
    display: block;
    justify-content: space-between;
  }

  .products {
    padding: 25px 5px;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1rem 0;
  }

  .header-buttons {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
  }

  .header-btn {
    order: 1;
    align-self: center;
    max-width: 270px;
  }

  .cart-column {
    left: 10px;
    right: 10px;
    width: auto;
    max-height: 45vh;
  }

  .pecas-tab {
    padding: 20px 0px;
  }

  .pecas-content {
    gap: 16px;
  }

  .pecas-main-title {
    font-size: 18px;
  }

  .pecas-subtitle {
    font-size: 13px;
  }

  .pecas-actions-bar {
    align-items: center;
    gap: 12px;
  }

  .pecas-add-btn {
    width: 100%;
    justify-content: center;
  }

  .pecas-info-text {
    align-items: flex-start;
    gap: 8px;
  }

  .pecas-body {
    padding: 12px 0;
    border-radius: 4px;
  }

  .pecas-loading-card {
    padding: 20px;
  }

  .pecas-loading-item {
    min-width: 100%;
  }

  .pecas-alert-actions {
    flex-direction: column;
  }

  .pecas-alert-cancel-btn,
  .pecas-alert-confirm-btn {
    width: 100%;
  }

  .pecas-empty-state {
    padding: 30px 20px;
  }

  .pecas-empty-title {
    font-size: 16px;
  }

  .pecas-empty-text {
    font-size: 13px;
  }
}
</style>
